import { Divider } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { useObserver } from 'mobx-react-lite';
import React, { useContext, useState, useEffect } from 'react';
import LoadingIndicator from '../common/LoadingIndicator';
import NoResultsText from '../common/NoResultsText';
import MobxContext from '../mobx/MobxContext';
import ApprovalsTable from './ApprovalsTable';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1100,
      margin: 'auto'
    },
    tabs: {
      marginBottom: 16
    },
    textFieldInput: {
      paddingTop: 12,
      paddingBottom: 12
    },
    toolbar: {
      marginBottom: 8
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    }
  })
);

function approvalFilter(approval, search) {
  return !search || (approval.WorkflowName.toLowerCase().includes(search) || approval.FamilyName.toLowerCase().includes(search));
}

function ApprovalsPage() {
  const classes = useStyles({});
  const [tab, setTab] = useState('myApprovals');
  const [search, setSearch] = useState('');
  const { approvalStore } = useContext(MobxContext);

  useEffect(() => {
    approvalStore.loadApprovals();
  }, [approvalStore]);

  function onTabChange(event: React.ChangeEvent<{}>, newValue: string) {
    setTab(newValue);
  }

  function onSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    setSearch(event.target.value);
  }

  const normalizedSearch = search.toLowerCase();

  let filteredApprovals = approvalStore.approvals ?
    tab === 'myApprovals' ? approvalStore.approvals.filter(approval => approval.pending && approval.groupMatches.length > 0) : approvalStore.approvals : [];

  if (normalizedSearch) {
    filteredApprovals = filteredApprovals.filter(approval => approvalFilter(approval, normalizedSearch));
  }

  return useObserver(() => (
    <div className={classes.root}>
      <Typography variant="h6">Approvals</Typography>
      <Divider className={classes.divider} light />
      <Tabs
        className={classes.tabs}
        value={tab}
        onChange={onTabChange}
        aria-label="Approval tabs"
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="For My Approval" value="myApprovals" />
        <Tab label="All Pending Approvals" value="allApprovals" />
      </Tabs>
      <div className={classes.toolbar}>
        <TextField
          id="search"
          value={search}
          fullWidth
          margin="none"
          variant="outlined"
          placeholder="Search by name or family"
          inputProps={{ 'aria-label': 'bare', className: classes.textFieldInput }}
          onChange={onSearchChange}
        />
      </div>
      {filteredApprovals.length > 0 && <Paper>
        {approvalStore.approvals && <ApprovalsTable
          approvals={filteredApprovals}
        />}
      </Paper>}
      {approvalStore.approvals && filteredApprovals.length === 0 && <NoResultsText>No approvals</NoResultsText>}
      <LoadingIndicator loading={!approvalStore.approvals} />
    </div>
  ));
};

export default ApprovalsPage;
